module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section",
    attrs: {
      "id": "do"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-10 is-offset-1 has-text-centered"
  }, [_c('h1', {
    staticClass: "title is-2"
  }, [_vm._v("What I Do")]), _vm._v(" "), _c('separator'), _vm._v(" "), _c('h2', {
    staticClass: "subtitle is-5"
  }, [_vm._v("I am a Web Developer and Gamers.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, _vm._l((_vm.panels), function(panel) {
    return _c('div', {
      key: panel.id,
      staticClass: "column do-col",
      class: ("is-" + (12 / _vm.panels.length))
    }, [_c('div', {
      staticClass: "panel"
    }, [_c('div', {
      staticClass: "panel-block"
    }, [_c('p', {
      staticClass: "has-text-centered"
    }, [_c('i', {
      staticClass: "fa icon-block",
      class: panel.icon
    })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h1', {
      staticClass: "title is-5"
    }, [_vm._v(_vm._s(panel.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(panel.text))])])])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-144ae4a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Do.vue
// module id = 540
// module chunks = 1